const ContentLayout = (props) => {
  return (
    <div id="content-layout">
      <div
        className="map-control"
        style={{ width: "100%", margin: "0px !important" }}
      >
        {props.children}
      </div>
    </div>
  );
};

export default ContentLayout;
